const machine_txt = {
    type: "VA-L01-S4",
    name: "Direct Drive High Speed Computerized Lockstitch Sewing Machine",
    description: [
        "Heighten design in rear cover and cover axis design to avoid oil leakage and operating more safely.",
        "The stitch length is controlled by a computer,and the stitch length can precisely overlap at each step of reverse sewing.",
        "It can handle both thin and thick fabrics, has a strong ability to sew thick fabrics,reduces the burden on the sewing machine each time the fabric thickness changes,further expands the sewing range,and is suitable for sewing various fabrics such as denim and yarn."
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/3/machine_img/1.jpg",
        "/assets/machine/3/machine_img/2.jpg",
        "/assets/machine/3/machine_img/3.jpg",
        "/assets/machine/3/machine_img/4.jpg",
    ],
    machine_other_img:[
        "/assets/machine/3/machine_other/1.png",
    ]
}
export default {machine_txt}